module.exports = __webpack_public_path__ + "static/img/logoCabra-22922f11824ab41d2939a9d7a87c9ba9-2.22922f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoCabra-22922f11824ab41d2939a9d7a87c9ba9-2.svg
// module id = cIE9
// module chunks = 0